export default [
  // Stylowanie i layout
  'CSS',
  'SCSS',
  'Sass',
  'Less',
  'Stylus',

  // HTML i języki szablonów
  'HTML',
  'XML',
  'EJS',
  'Handlebars',
  'Mustache',
  'Pug',

  // Notatniki i dokumentacja
  'Jupyter Notebook',
  'Markdown',
  'reStructuredText',
  'AsciiDoc',
  'LaTeX',

  // Konfiguracja i automatyzacja
  'Makefile',
  'CMake',
  'Dockerfile',
  'Batchfile',
  'Shell',
  'PowerShell',
  'INI',
  'TOML',
  'YAML',
  'JSON',
  'HCL',
  'Inno Setup',

  // Języki niszowe lub używane rzadko
  'QML',
  'Nix',
  'Objective-C',
  'COBOL',
  'Ada',
  'VHDL',
  'Verilog',
  'Scheme',
  'Common Lisp',
  'Crystal',
  'Elm',
  'PureScript',
  'Hack',
]
